// export const SET_CLIENT_LIST = 'SET_CLIENT_LIST'
// export const IS_LOADING_CLIENT_LIST = 'IS_LOADING_CLIENT_LIST'
export const WS_OPEN = 'SOCKET_ONOPEN';
export const WS_CLOSE = 'SOCKET_ONCLOSE';
export const WS_ERROR = 'SOCKET_ONERROR';
export const WS_MESSAGE = 'SOCKET_ONMESSAGE';
export const WS_SET_CLIENT_ID = 'SOCKET_SET_CLIENT_ID';
export const WS_RECONNECT = 'SOCKET_RECONNECT';
export const WS_RECONNECT_ERROR = 'SOCKET_RECONNECT_ERROR';
